module.exports = __webpack_public_path__ + "img/logo.0ee9a7ca.png";